import { styled } from '@linaria/react';
import { bodyFont, colors, fonts, headingFont, layout, semantic, space } from '../../theme/tokens';

export const FooterBar = styled.footer<{ $align?: 'left' | 'right' }>`
  position: fixed;
  bottom: var(--sticky-footer-offset-bottom, ${layout.mobileNavHeight});
  left: 0;
  right: 0;
  background: ${colors.white};
  border-top: 1px solid ${semantic.border.subtle};
  padding: ${space[4]} ${space[5]};
  display: flex;
  align-items: center;
  justify-content: ${({ $align }) => ($align === 'right' ? 'flex-end' : 'space-between')};
  gap: ${space[5]};
  z-index: 103;
  width: 100%;
  box-sizing: border-box;

  @media (min-width: ${layout.desktopBreakpoint}) {
    position: sticky;
    left: auto;
    right: auto;
    z-index: 10;
  }
`;

export const FooterSpacer = styled.div`
  height: var(--sticky-footer-height, 88px);
  flex-shrink: 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: none;
  }
`;

export const FooterLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[1]};
`;

export const FooterTitle = styled.span`
  font-family: ${headingFont};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
`;

export const FooterTotal = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.bold};
  color: ${semantic.text.primary};
`;

export const FooterOriginalPrice = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.tertiary};
  text-decoration: line-through;
`;

export const FooterDiscountedPrice = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.bold};
  color: ${semantic.text.primary};
`;

export const FooterPriceRow = styled.span`
  display: inline-flex;
  align-items: baseline;
  gap: 0.4rem;
`;
